import { render, staticRenderFns } from "./approve-list-page.html?vue&type=template&id=00a869e9&"
import script from "./approve-list-page.ts?vue&type=script&lang=ts&"
export * from "./approve-list-page.ts?vue&type=script&lang=ts&"
import style0 from "./approve-list-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports